<template>
  <v-tooltip 
    :top="position === 'top' ? true : false"
    :bottom="position === 'bottom' ? true : false"
  >
    <template v-slot:activator="{ on, attrs }">
      <span :class="className" text v-bind="attrs" v-on="on">
        {{ text }}
      </span>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: "top", // top, bottom
    },
    className: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
